module.exports = __webpack_public_path__ + "img/children.4695c8d5.png";